import { Box, Checkbox } from "@mui/material";
import { useRecoilState } from "recoil";
import type { ChangeEvent } from "react";
import { CheckboxLabelWrapper, OptionLabel } from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import {
  getAneuploidyChoiceColumnSx,
  unselectedCheckboxSx,
} from "./testPanelStyles";

type NewReqClinicalIndicationAneuploidyChoiceProps = {
  active: boolean;
};

const NewReqClinicalIndicationAneuploidyChoice = ({
  active,
}: NewReqClinicalIndicationAneuploidyChoiceProps) => {
  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );
  const { requisitionForm } = newRequisition;
  const { deviceType } = useDeviceHook();

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setNewRequisition((current) => ({
      ...current,
      requisitionForm: {
        ...current.requisitionForm,
        [name]: checked,
      },
    }));
  };

  const addOnsDisabled = !active || requisitionForm.disableAneuploidy;
  const columnSx = getAneuploidyChoiceColumnSx(deviceType, addOnsDisabled);

  return (
    <Box sx={columnSx}>
      <CheckboxLabelWrapper
        label={
          <OptionLabel>
            Add <strong>Fetal RhD</strong> for RhD-negative mothers (no
            D-alloimmunization)
          </OptionLabel>
        }
        control={
          <Checkbox
            sx={unselectedCheckboxSx}
            checked={active && requisitionForm.aneuploidyIncludeRhd}
            disabled={addOnsDisabled || requisitionForm.isFetalAntigenD}
            name="aneuploidyIncludeRhd"
            onChange={onChange}
          />
        }
      />
    </Box>
  );
};
export default NewReqClinicalIndicationAneuploidyChoice;
